    const vendorElements = document.querySelectorAll('.card_vendor');
    vendorElements.forEach(function(el) {
        const vendorText = el.textContent.trim();
        const vendorsToHide = ['Interior Center Zen'];
        
        if (vendorsToHide.includes(vendorText)) {
            el.style.display = 'none';
        }
    });